module.exports = __webpack_public_path__ + "static/media/spilling.ef557294.mp4";